import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Cta} from '../../blocks';
import {IS_MOBILE} from "../../constants/environment";

class EstimateLink extends PureComponent {

  static propTypes = {
    carId: PropTypes.string,
    carTypeCode: PropTypes.string,
    estimationDisplay: PropTypes.string,
    gradeId: PropTypes.string,
    gradeCode: PropTypes.string,
    engine: PropTypes.string,
    drive: PropTypes.string,
    mission: PropTypes.string,
    colorId: PropTypes.string,
    accessoryIdList: PropTypes.array,
  };

  static defaultProps = {
    carId: null,
    carTypeCode: null,
    estimationDisplay: null,
    gradeId: null,
    gradeCode: null,
    engine: null,
    drive: null,
    mission: null,
    colorId: null,
    accessoryIdList: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      href: '/purchase/estimate/',
      // href: 'https://ssl.mazda.co.jp/sp/purchase/estimate/',
    }
  }

  render() {
    return (
      <div className="ExteriorView__estimate">
        <Cta
          {...{
            ctaType: 'Free',
            href: this.state.href,
            text: 'このモデルの見積もりシミュレーション',
            targetBlank: false,
            linkType: 'Button',
            color: 'Light',
            buttonStyle: 'Standard',
          }}
        />
      </div>
    )
  }

  componentDidMount() {
    let href = '/purchase/estimate/';
    href = href + '?car_id=' + this.props.carId;
    href = href + '&car_type_code=' + this.props.carTypeCode;
    href = href + '&grade_code=' + this.props.gradeCode;
    href = href + '&aic=' + this.props.colorId;
    href = href + '&drive=' + this.props.drive;
    href = href + '&engine=' + this.props.engine;
    href = href + '&mission=' + this.props.mission;
    // ショップオプション
    let str = '';
    this.props.accessoryIdList.map((accessoryId, index) => {
      str = str + accessoryId + ':'
    });
    if (str !== '') {
      href = href + '&soptions=' + str.slice(0, -1);
    }
    // 遷移画面
    if (this.props.estimationDisplay === 'Grade') {
      href = href + '&direct=id_contents_grade';
    } else if (this.props.estimationDisplay === 'Color-And-Sheet') {
      href = href + '&direct=id_contents_color';
    } else if (this.props.estimationDisplay === 'Maker-Set-Option') {
      href = href + '&direct=id_contents_maker';
    } else if (this.props.estimationDisplay === 'Shop-Option') {
      href = href + '&direct=id_contents_shop';
    } else if (this.props.estimationDisplay === 'Result') {
      href = href + '&direct=id_contents_estimate';
    }
    this.setState({
      href: href,
    })
  }

  componentWillReceiveProps(nextProps) {
    let href = '/purchase/estimate/';
    href = href + '?car_id=' + nextProps.carId;
    href = href + '&car_type_code=' + nextProps.carTypeCode;
    href = href + '&grade_code=' + nextProps.gradeCode;
    href = href + '&aic=' + nextProps.colorId;
    href = href + '&drive=' + nextProps.drive;
    href = href + '&engine=' + nextProps.engine;
    href = href + '&mission=' + nextProps.mission;

    // ショップオプション
    let str = '';
    nextProps.accessoryIdList.map((accessoryId, index) => {
      str = str + accessoryId + ':'
    });
    if (str !== '') {
      href = href + '&soptions=' + str.slice(0, -1);
    }

    // 遷移画面
    if (nextProps.estimationDisplay === 'Grade') {
      href = href + '&direct=id_contents_grade';
    } else if (nextProps.estimationDisplay === 'Color-And-Sheet') {
      href = href + '&direct=id_contents_color';
    } else if (nextProps.estimationDisplay === 'Maker-Set-Option') {
      href = href + '&direct=id_contents_maker';
    } else if (nextProps.estimationDisplay === 'Shop-Option') {
      href = href + '&direct=id_contents_shop';
    } else if (nextProps.estimationDisplay === 'Result') {
      href = href + '&direct=id_contents_estimate';
    }

    this.setState({
      href: href,
    })
  };

}

export default EstimateLink;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/EstimateLink.jsx